import _ from 'lodash';
import validator from 'validator';

function run(rule, v = '') {
  const type = _.get(rule, 'type');
  const customValidator = _.get(rule, 'validate.validator');

  if (customValidator) {
    return new Function('_', 'validator', 'v', customValidator) // eslint-disable-line no-new-func
      .bind(this, _, validator, v)
      .call();
  }

  switch (type) {
    case 'Date':
      return v instanceof Date && !isNaN(v);
    case 'Boolean':
      return validator.isBoolean(v);
    case 'Number':
      return !isNaN(parseInt(v, 10));
    case 'String':
    case 'ObjectId':
    default:
      return true;
  }
}

export default {
  run,
};
